import { BrowserStorage } from '@estee/elc-universal-utils';
import { VTO_SURVEY_STORAGE_KEY } from '../constants/Survey';
import { VtoTypes } from '../constants/Vto';
import { ISurveyStorage, ISurveyStorageValues } from '../interfaces/ISurvey';
import { getVtoSurveyStorage } from './getVtoSurveyStorage';

interface ISetVtoSurveyStorage {
    vtoType: string;
    data: ISurveyStorageValues;
}

const defaultSurveyData = Object.values(VtoTypes).reduce((acc, value) => {
    return {
        ...acc,
        [value]: {
            isP13nApiVerified: false,
            isSurveyTaken: false
        }
    };
}, {});

export const setVtoSurveyStorage = ({ vtoType, data }: ISetVtoSurveyStorage) => {
    const storage = getVtoSurveyStorage() || defaultSurveyData;

    const newSurveyData: ISurveyStorage = {
        ...storage,
        [vtoType]: {
            ...storage[vtoType],
            ...data
        }
    };

    BrowserStorage.setItem(VTO_SURVEY_STORAGE_KEY, JSON.stringify(newSurveyData));
};
